import React, { useEffect, useState } from "react";
import logo from '../../assets/images/CoreVentum_logo_dark.png';
import DemoRequestComponent from "../../components/forms/DemoRequest";
import axiosInstance from "../../utils/axiosInstance";
import { Button, Calendar, Card, List, message, Select } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import SuccessCard from "../../components/messages/SuccessCard";
import {
  LeftOutlined
} from "@ant-design/icons";
import img1 from "../../assets/images/img1.png";
import img2 from "../../assets/images/img2.png";

const timezones = [
  "Asia/Kolkata",
  "Asia/Dubai",
];
const generateAvailableSlots = (timezone = "Asia/Kolkata") => {
  const slots = {};
  const startHour = 10;
  const endHour = 18;

  for (let i = 0; i < 30; i++) {
    const date = dayjs().tz(timezone).add(i, "day");
    const dayOfWeek = date.day(); // 0 (Sunday) - 6 (Saturday)

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      // Only Monday - Friday
      const formattedDate = date.format("YYYY-MM-DD");
      slots[formattedDate] = [];

      for (let hour = startHour; hour < endHour; hour++) {
        slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:00`);
        slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:30`);
      }
    }
  }
  return slots;
};

const convertTime = (time, date, selectedTimezone, localTimeZone) => {
  const localDateTime = dayjs.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", localTimeZone).tz(selectedTimezone);
  const adjustedDate = localDateTime.format("YYYY-MM-DD");
  const adjustedTime = localDateTime.format("HH:mm");
  return { adjustedDate, adjustedTime }
}

export default function DemoScheduler() {
  const [selectedTime, setSelectedTime] = useState(null);
  const [availableData, setAvailableData] = useState({});
  const [unavailableData, setUnavailableData] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [bookedSlots, setBookedSlots] = useState(unavailableData);
  const [selectedTimezone, setSelectedTimezone] = useState("Asia/Kolkata");
  const [timezoneAdjustedData, setTimezoneAdjustedData] = useState({});
  const [timezoneAdjustedUnavailable, setTimezoneAdjustedUnavailable] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);


  const getDate = async () => {
    try {
      const response = await axiosInstance.get(`/demo/busy-slots/`);
      setUnavailableData(response.data.blocked_slots);
    } catch (error) {
      message.error(error.response.data.error);
    }
  }
  useEffect(() => {
    getDate()
  }, []);

  useEffect(() => {
    const rawAvailableData = Object.keys(availableData).length > 0 ? { ...availableData } : generateAvailableSlots(selectedTimezone);
    const adjustTimeData = (data) => {
      const adjustedData = {};
      Object.keys(data).forEach((date) => {
        data[date].forEach((time) => {
          const { adjustedDate, adjustedTime } = convertTime(time, date, selectedTimezone, "Asia/Kolkata");
          if (!adjustedData[adjustedDate]) adjustedData[adjustedDate] = [];
          adjustedData[adjustedDate].push(adjustedTime);
        });
      });
      return adjustedData;
    };

    const adjustedAvailableData = adjustTimeData(rawAvailableData);
    const adjustedUnavailableData = adjustTimeData(bookedSlots);
    setTimezoneAdjustedData(adjustedAvailableData);
    setTimezoneAdjustedUnavailable(adjustedUnavailableData);
  }, [selectedTimezone, availableData, bookedSlots]);

  useEffect(() => {
    setBookedSlots(unavailableData)
  }, [unavailableData])

  const handleDateSelect = (value) => {
    setSelectedDate(value.format("YYYY-MM-DD"));
  };

  const dateCellRender = (value) => {
    return timezoneAdjustedData[value.format("YYYY-MM-DD")] ? null : <div style={{ color: "#bbb" }}></div>;
  };

  const isPast = (date, slot) => dayjs.tz(`${date} ${slot}`, "YYYY-MM-DD HH:mm", selectedTimezone).isBefore(dayjs().tz(selectedTimezone));

  const getFormattedDate = (date) => {
    if (!date) return "";
    const dayjsDate = dayjs(date);
    const day = dayjsDate.date();

    // Get ordinal suffix
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th"; // 11-13
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const suffix = getOrdinal(day);
    const formatted = `${dayjsDate.format("dddd, MMMM")} ${day}${suffix} ${dayjsDate.format("YYYY")}`;
    return formatted;
  };
  const dateTime = selectedDate && selectedTime
    ? dayjs(`${selectedDate} ${selectedTime}`).format("YYYY-MM-DDTHH:mm")
    : null;
  return (
    <div className="h-screen w-full bg-cover bg-center relative flex"
      style={{ backgroundImage: `url(${img2})` }}>
      <nav className="pl-3 pt-4">
        <img src={logo} alt="" width={180} height={150} />
      </nav>
      <div className="absolute top-2 left-[15%] lg:w-[40%] xl:w-[45%]">
        <h1 className="text-white font-extrabold text-[18px] my-2 text-center">Contract Life-Cycle Management Software (CLMS)</h1>
        <img
          src={img1}
          alt="Top Right"
          className=""
        />
      </div>

      {/* Right Section */}
      <div className="absolute bottom-16 right-14 text-white w-full max-w-[450px] z-20">
        <div className="glass-card shadow-lg rounded-lg p-10 w-full max-w-lg h-full">
          {/* Calendar */}
          {!selectedDate && (
            <div>
              <div className="flex items-center gap-3">
                <h2 className="text-lg font-semibold text-white">Contract Life-Cycle Management Software Demo</h2>
              </div>
              <h3 className="text-center text-lg font-medium mb-2">Select Day</h3>
              <Card className="mb-10px glass-card">
                <Calendar
                  fullscreen={false}
                  defaultValue={dayjs()}
                  onSelect={handleDateSelect}
                  dateCellRender={dateCellRender}
                  disabledDate={(date) => !timezoneAdjustedData[date.format("YYYY-MM-DD")]}
                />
              </Card>
              <div className="text-center text-sm text-gray-400 mt-4">
                <Select
                  style={{ width: 200, margin: "10px 0" }}
                  value={selectedTimezone}
                  onChange={setSelectedTimezone}
                  className="glass-card"
                >
                  {timezones.map((tz) => (
                    <Select.Option key={tz} value={tz}>
                      {tz}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          )}

          {/* Time Slots */}
          {selectedDate && !selectedTime && (
            <div >
              <h3 className="text-center text-lg font-medium mb-2">
                Select Time
              </h3>
              <div className="text-sm text-gray-400 mb-[4px] flex justify-between text-center items-center">
                <button
                  onClick={() => setSelectedDate(null)}
                  className="text-white font-bold text-xl"

                >
                  <LeftOutlined />
                </button>
                <div>

                  {`${getFormattedDate(selectedDate)} | 30 minutes`}
                </div>
                <div>

                </div>
              </div>
              <div className="flex flex-col gap-3 h-[430px] overflow-y-scroll">
                {selectedDate && timezoneAdjustedData[selectedDate] ? (
                  <List
                    dataSource={timezoneAdjustedData[selectedDate]}
                    renderItem={(time) => (
                      <List.Item>
                        <Button
                          type="primary"
                          block
                          style={{
                            backgroundColor:
                              timezoneAdjustedUnavailable[selectedDate]?.includes(time) || isPast(selectedDate, time)
                                ? "transparent"
                                : "#122253",
                            borderColor: "#122253",
                            color:
                              timezoneAdjustedUnavailable[selectedDate]?.includes(time) || isPast(selectedDate, time)
                                ? "#000000"
                                : "#ffffff"
                          }}
                          disabled={timezoneAdjustedUnavailable[selectedDate]?.includes(time) || isPast(selectedDate, time)}
                          onClick={() => { setSelectedTime(time) }}
                        >
                          {timezoneAdjustedUnavailable[selectedDate]?.includes(time) ? `Not Available ${time}` : `Book ${time}`}
                        </Button>
                      </List.Item>
                    )}
                  />
                ) : (
                  <div className="flex h-full font-semibold text-xl text-[#ffffff] justify-center items-center">No available slots</div>
                )}
              </div>
            </div>
          )}

          {/* Confirmation Form */}
          {selectedDate && selectedTime && (
            <div>
              <h3 className="text-center text-lg font-medium mb-2">
                Confirm Booking
              </h3>
              <div className="text-sm text-gray-400 mb-[16px] text-center flex justify-between items-center">
                <button onClick={() => setSelectedTime(null)} className="p-0 text-white font-bold text-xl">
                  <LeftOutlined />
                </button>
                <div>

                  {`${getFormattedDate(selectedDate)} | ${selectedTime} - 30 minutes`}
                </div>
                <div>

                </div>
              </div>
              <DemoRequestComponent date_time={dateTime} onSuccess={() => setShowSuccess(true)} />
            </div>
          )}

        </div>


      </div>
      <SuccessCard
        message={`Your Demo Request Submitted`}
        isVisible={showSuccess}
        onClose={() => setShowSuccess(false)}
      />
    </div>
  );
}